export interface MegacableLoginRequest {
  username: string;
  password: string;
}

export interface MegacableLoginResponse {
  creditEnable: boolean;
  tokenType: string;
  accessToken: string;
  expiresAt: number;
}

export class MegacableLoginError extends Error {
  constructor(
    readonly userMessage: string,
    readonly status?: number
  ) {
    super(userMessage);
    this.name = 'MegacableLoginError';
  }
}
